module.exports = __webpack_public_path__ + "img/idcard-positive.12c84942.jpg";